import request from "@/utils/request";


/**
 * 合同文件查询
 * @param params
 * @returns {AxiosPromise}
 */
export function getTemplatePage(params){
    return request({
        url: '/system/template',
        method: 'get',
        params
    })
}

/**
 * 合同文件列表
 * @param params
 * @returns {AxiosPromise}
 */
export function getTemplateList(params){
    return request({
        url: '/system/template/list',
        method: 'get',
        params
    })
}

/**
 * 编辑流程
 * @param data
 * @returns {AxiosPromise}
 */
export function editTemplate(data){
    return request({
        url: '/system/template',
        method: 'post',
        data
    })
}
/**
 * 删除流程
 * @returns {AxiosPromise}
 * @param id
 */
export function delTemplate(id){
    return request({
        url: `/system/template/${id}`,
        method: 'delete'
    })
}

/**
 * 流程详情
 * @param params
 * @returns {AxiosPromise}
 */
export function getTemplateDetail(params){
    return request({
        url: `/system/template/${params.id}`,
        method: 'get'
    })
}
